import React from 'react';
import { Dialog, Card } from '@mui/material';
import { icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import NewButton from '../Buttons/NewButton';

const DeleteGeofenceModal = ({show, fences, onClose, deleteFences}) => {
    const { t } = useTranslation();


    const returnFenceIds = () => {
		let checked = fences?.filter(fence => fence.selected).map(fence => parseInt(fence.id));
		return checked
	}
    return(
        <>
        <Dialog open={show} onClose={onClose}>
            <Card className="settings-dialog d-flex flex-column scrollable-y">
                <div className="w-100 h-100">
                    <div className="p-3">
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className='d-flex align-items-center'>
                                <h3 className="">{t("geofence.delete_geofence")}</h3>
                            </div>
                            <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." />
                        </div>
                        <p className="grey-blue py-3">{t("geofence.delete_geofence_copy1", { count: 1 })}</p>
                        {fences?.map((fence, index) => (
                            <p key={index} className="bold ms-2">{fence?.name}</p>
                        ))}
                        <p className="grey-blue pt-3">{t("geofence.delete_geofence_copy2", { count: 1 })}</p>
                        <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                            <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("geofence.cancel")}</NewButton>
                            <NewButton onClick={() => deleteFences(returnFenceIds())} className="bg-red p-3 rounded24 w-100 white ms-2 body bold">{t("geofence.delete_geofence")}</NewButton>
                        </div>
                    </div>
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default DeleteGeofenceModal;